import React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import { useNavigate, useSearchParams } from "react-router-dom";
import { buttonStyle, iconColor } from "./colors";
import Button from "@mui/material/Button";
import { FaLock } from "react-icons/fa6";
import Outfit from "./outfits/outfit 1.png";
import {
  ALL_USERS,
  getRandomEvent,
  getRandomNumber,
  getRandomOutfit,
  getRandomStyles,
} from "./Data";
import Snackbar from "@mui/material/Snackbar";
import { IconButton } from "@mui/material";
import { BsThreeDots } from "react-icons/bs";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const BUTTON_LABELS = ["Add Friend", "Cancel Add", "Added!"];

function Friend(props) {
  const [activeTab, setActivetab] = React.useState(0);
  const [isSearching, setIsSearching] = React.useState(false);
  const [value, setValue] = React.useState("");
  const inputRef = React.useRef();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const user = parseInt(searchParams.get("user"));
  const navbarActive = searchParams.get("active") ?? "2";


  // 0: Unadded, 1: Pending, 2: Added
  const [addState, setAddState] = React.useState(user === 0 ? 2 : 0);
  const timeoutRef = React.useRef();

  const [open, setOpen] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const { username, pfp } = ALL_USERS[user];

  const dataKey = "friend" + user;
  const numFriends = getRandomNumber("num_friends" + dataKey, 5, 100);
  const styles = getRandomStyles(dataKey, 2);
  let numOutfits, outfits;
  if (activeTab === 0) {
    numOutfits = getRandomNumber("num_outfits" + dataKey, 1, 3) * 3;
    outfits = getRandomOutfit(dataKey, numOutfits);
  } else {
    outfits = getRandomOutfit("choose" + dataKey, 2);
  }

  return (
    <NavBarLayout
      title={navbarActive === "3" ? "Profile" : "Friends"}
      onBackButtonClicked={() => navigate(-1)}
      active={parseInt(navbarActive)}
    >
      <Snackbar
        sx={{ top: "10%" }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        message={`${username} added you back!`}
      />
      <div className="FriendsFeed-container">
        <div className="FriendsSearch-upper">
          <div className="Friend-profileOuterContainer">
            <div className="Friend-usernameBar">
              <div style={{ width: "48px" }}></div>
              <div className="Friend-username">{username}</div>
              <div
                style={{
                  marginRight: "8px",
                  ...(user === 0 ? { visibility: "hidden" } : {}),
                }}
              >
                <IconButton onClick={handleClick}>
                  <BsThreeDots />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleCloseMenu}
                >
                  <MenuItem onClick={handleCloseMenu}>Report User</MenuItem>
                  <MenuItem onClick={handleCloseMenu}>Block User</MenuItem>
                </Menu>
              </div>
            </div>
            <div className="Friend-profileInnerContainer">
              <img
                style={user === 0 ? { backgroundColor: "black" } : {}}
                className="Friend-pfp"
                src={pfp}
                alt=""
              ></img>
              <div className="Friend-profileInfo">
                <div className="Friend-friendCount">{numFriends} friends</div>
                <Button
                  onClick={() => {
                    if (user === 0) {
                      navigate("/editprofile");
                    }

                    if (addState === 0) {
                      setAddState(1);
                      timeoutRef.current = setTimeout(() => {
                        setAddState(2);
                        setOpen(true);
                      }, 3000);
                    } else if (addState === 1) {
                      setAddState(0);
                      clearTimeout(timeoutRef.current);
                    }
                  }}
                  sx={{
                    boxShadow: "none !important",
                    fontSize: "20px",
                    paddingRight: "40px",
                    paddingLeft: "40px",
                  }}
                  variant="contained"
                  disabled={addState === 2 && user !== 0}
                >
                  {user === 0 ? "Edit profile" : BUTTON_LABELS[addState]}
                </Button>
                <div className="Friend-style">
                  <b>Style:</b> {styles.join(", ")}
                </div>
              </div>
            </div>
          </div>
          {addState === 2 && (
            <div
              className="Friend-upperBar"
              style={isSearching ? { justifyContent: "flex-start" } : {}}
            >
              <div
                onClick={() => setActivetab(0)}
                className={`FriendsFeed-tab ${
                  activeTab === 0 ? "FriendsFeed-tabActive" : ""
                }`}
              >
                #OOTDs
              </div>
              <div
                onClick={() => setActivetab(1)}
                className={`FriendsFeed-tab ${
                  activeTab === 1 ? "FriendsFeed-tabActive" : ""
                }`}
              >
                Choose
              </div>
            </div>
          )}
        </div>
        {addState === 2 ? (
          <div
            style={
              activeTab === 1
                ? { fontSize: 20, textAlign: "center", marginTop: "1rem" }
                : {}
            }
            className="FriendsFeed-mainScrollContainer"
          >
            {activeTab === 1 && getRandomEvent(username, 1)}
            <div
              style={activeTab === 1 ? { top: 50 } : {}}
              className="Friend-mainScroll"
            >
              {outfits.map((outfit) => (
                <img className="Friend-card" src={outfit} />
              ))}
            </div>
          </div>
        ) : (
          <div className="Friend-lockContainer">
            <div className="Friend-lockInnerContainer">
              <FaLock color="white" size="8rem" />
              <div className="Friend-lockText">
                Add this user to see their #OOTD!
              </div>
            </div>
          </div>
        )}
      </div>
    </NavBarLayout>
  );
}

export default Friend;
